import { consola } from 'consola'

// Logger
const logger = consola.withTag('payment-middleware')

/**
 * Middleware для страниц обработки платежей (success/fail)
 * 
 * ✅ Предотвращает автоматическое разлогинивание при возможных ошибках API
 * ✅ Устанавливает временный флаг для пропуска проверки токенов
 * ✅ Автоматически очищает флаг через 10 секунд
 * 
 * @note Работает совместно с auth.global.ts
 */
export default defineNuxtRouteMiddleware(async (to, _from) => {
  // Проверяем, что это страницы платежей
  const isPaymentResultPage = to.path === '/success' || to.path === '/fail'
  
  if (!isPaymentResultPage) {
    return
  }
  
  logger.info('Страница обработки платежа:', to.path)
  
  // Для страниц результата платежа временно отключаем строгую проверку токенов
  // Это предотвращает разлогинивание при переходе с внешних платежных систем
  if (process.client) {
    // Устанавливаем временный флаг
    sessionStorage.setItem('payment_processing', 'true')
    logger.debug('Установлен флаг payment_processing для защиты сессии')
    
    // Очищаем флаг через 10 секунд
    setTimeout(() => {
      sessionStorage.removeItem('payment_processing')
      logger.debug('Флаг payment_processing очищен')
    }, 10_000)
  }
})
